(function () {
  'use strict';

  var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function init() {
    document.querySelectorAll('.shopify-section--social-videos').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('shopify-section--social-videos')) {
      event.target.removeAttribute('data-social-videos-init');
      initSection(event.target);
    }
  });

  function initSection(sectionEl) {
    if (sectionEl.dataset.socialVideosInit === 'true') return;
    sectionEl.dataset.socialVideosInit = 'true';

    var sectionId = sectionEl.id.replace('shopify-section-', '');
    var dataEl = document.getElementById('social-videos-data-' + sectionId);
    if (!dataEl) return;

    var videoData;
    try {
      videoData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var modal = document.getElementById('social-video-modal-' + sectionId);
    if (!modal) return;

    var modalVideo = modal.querySelector('.hauswirt-social-videos-modal__video');
    var modalEmbed = modal.querySelector('.hauswirt-social-videos-modal__embed');
    var modalProducts = modal.querySelector('.hauswirt-social-videos-modal__products');
    var closeBtn = modal.querySelector('.hauswirt-social-videos-modal__close');
    var backdrop = modal.querySelector('.hauswirt-social-videos-modal__backdrop');
    var sourceLink = modal.querySelector('.hauswirt-social-videos-modal__source-link');
    var videoFooter = modal.querySelector('.hauswirt-social-videos-modal__video-footer');

    /* ===== Carousel nav ===== */
    var track = document.getElementById('social-videos-track-' + sectionId);
    var prevBtn = sectionEl.querySelector('.hauswirt-social-videos__nav--prev');
    var nextBtn = sectionEl.querySelector('.hauswirt-social-videos__nav--next');

    function getScrollStep() {
      var firstItem = track.querySelector('.hauswirt-social-videos__item');
      if (!firstItem) return 300;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      return firstItem.offsetWidth + gap;
    }

    function updateNavVisibility() {
      if (!track || !prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.style.display = scrollLeft <= 2 ? 'none' : 'flex';
      nextBtn.style.display = scrollLeft >= maxScroll - 2 ? 'none' : 'flex';
    }

    if (prevBtn && nextBtn && track) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateNavVisibility, { passive: true });
      window.addEventListener('resize', updateNavVisibility);
      updateNavVisibility();
    }

    /* ===== Auto-fill creator names ===== */
    sectionEl.querySelectorAll('.hauswirt-social-videos__item').forEach(function (item) {
      var creatorEl = item.querySelector('.hauswirt-social-videos__creator-name');
      if (!creatorEl) return;
      if (creatorEl.textContent.trim() !== '') return;

      var cardEl = item.querySelector('.hauswirt-social-videos__card');
      if (!cardEl) return;
      var idx = parseInt(cardEl.getAttribute('data-video-index'), 10);
      var data = videoData[idx];
      if (!data || !data.videoUrl) return;

      var urlName = extractUsernameFromUrl(data.videoUrl);
      if (urlName) {
        creatorEl.textContent = urlName;
        var creatorWrap = item.querySelector('.hauswirt-social-videos__creator');
        if (creatorWrap) creatorWrap.style.display = '';
      }

      fetchCreatorName(data.videoUrl, function (name) {
        if (name) {
          creatorEl.textContent = name;
          var creatorWrap = item.querySelector('.hauswirt-social-videos__creator');
          if (creatorWrap) creatorWrap.style.display = '';
        }
      });
    });

    /* ===== Cards: hover + click ===== */
    sectionEl.querySelectorAll('.hauswirt-social-videos__card').forEach(function (card) {
      var previewVideo = card.querySelector('.hauswirt-social-videos__video');

      if (previewVideo && supportsHover) {
        card.addEventListener('pointerenter', function () {
          startPreview(card, previewVideo);
        });
        card.addEventListener('pointerleave', function () {
          stopPreview(card, previewVideo);
        });
      }

      card.addEventListener('click', function (e) {
        if (e.target.closest('.hauswirt-social-videos-modal__add-to-cart')) return;
        e.preventDefault();
        var index = parseInt(card.getAttribute('data-video-index'), 10);
        openModal(index);
      });
    });

    function startPreview(card, video) {
      card.classList.add('is-playing');
      video.muted = true;
      video.playsInline = true;
      if (video.readyState < 2) video.load();
      var p = video.play();
      if (p !== undefined) p.catch(function () {});
    }

    function stopPreview(card, video) {
      card.classList.remove('is-playing');
      video.pause();
      video.currentTime = 0;
    }

    /* ===== Modal ===== */
    function openModal(index) {
      var data = videoData[index];
      if (!data) return;

      modalVideo.classList.remove('is-active');
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.innerHTML = '';
      modalEmbed.classList.remove('is-active');
      modalEmbed.innerHTML = '';
      modalEmbed.removeAttribute('data-platform');
      if (videoFooter) videoFooter.style.display = 'none';

      var hasVideoFile = data.videoSources && data.videoSources.length > 0;
      var hasExternalUrl = !!data.videoUrl;

      if (hasVideoFile) {
        data.videoSources.forEach(function (source) {
          var sourceEl = document.createElement('source');
          sourceEl.src = source.url;
          sourceEl.type = source.mimeType;
          modalVideo.appendChild(sourceEl);
        });
        modalVideo.controls = true;
        modalVideo.setAttribute('controlsList', 'nodownload');
        modalVideo.load();
        modalVideo.classList.add('is-active');
        modalVideo.play().catch(function () {});
      } else if (hasExternalUrl) {
        var platform = detectPlatform(data.videoUrl);
        var embedUrl = getEmbedUrl(data.videoUrl);
        if (embedUrl) {
          modalEmbed.setAttribute('data-platform', platform);
          var iframe = document.createElement('iframe');
          iframe.src = embedUrl;
          iframe.setAttribute('allowfullscreen', 'true');
          iframe.setAttribute('allow', 'autoplay; fullscreen; encrypted-media');
          iframe.setAttribute('title', 'Social video');
          modalEmbed.appendChild(iframe);
          modalEmbed.classList.add('is-active');
        } else {
          renderExternalFallback(data.videoUrl, platform);
        }
      }

      if (hasExternalUrl && sourceLink && videoFooter) {
        var plat = detectPlatform(data.videoUrl);
        sourceLink.href = data.videoUrl;
        sourceLink.setAttribute('data-platform', plat);
        videoFooter.style.display = 'block';
        var sourceText = sourceLink.querySelector('.hauswirt-social-videos-modal__source-text');
        if (plat === 'tiktok') sourceText.textContent = 'Watch on TikTok';
        else if (plat === 'instagram') sourceText.textContent = 'Watch on Instagram';
        else if (plat === 'youtube') sourceText.textContent = 'Watch on YouTube';
        else if (plat === 'facebook') sourceText.textContent = 'Watch on Facebook';
        else sourceText.textContent = 'Watch original';
      }

      renderProducts(data.products || []);
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hauswirt-modal-open');
    }

    function renderExternalFallback(url, platform) {
      var platformName = platform === 'instagram' ? 'Instagram' :
        platform === 'tiktok' ? 'TikTok' :
        platform === 'youtube' ? 'YouTube' :
        platform === 'facebook' ? 'Facebook' :
        'Original post';
      var watchLabel = platformName === 'Original post' ? 'Watch original' : 'Watch on ' + platformName;

      modalEmbed.setAttribute('data-platform', platform);
      modalEmbed.innerHTML =
        '<div class="hauswirt-social-videos-modal__fallback">' +
          '<div class="hauswirt-social-videos-modal__fallback-inner">' +
            '<p class="hauswirt-social-videos-modal__fallback-title">Video preview is not available here.</p>' +
            '<p class="hauswirt-social-videos-modal__fallback-text">' + platformName + ' may block embedded playback for this post. You can still view the original video.</p>' +
            '<a class="hauswirt-social-videos-modal__fallback-link" href="' + escapeHtml(url) + '" target="_blank" rel="noopener noreferrer">' + watchLabel + '</a>' +
          '</div>' +
        '</div>';
      modalEmbed.classList.add('is-active');
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hauswirt-modal-open');
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.innerHTML = '';
      modalVideo.classList.remove('is-active');
      modalEmbed.innerHTML = '';
      modalEmbed.classList.remove('is-active');
      modalEmbed.removeAttribute('data-platform');
    }

    function renderProducts(products) {
      modalProducts.innerHTML = '';
      if (products.length === 0) return;

      products.forEach(function (product) {
        var card = document.createElement('div');
        card.className = 'hauswirt-social-videos-modal__product';

        var priceHtml = '<p class="hauswirt-social-videos-modal__product-price">' + product.price;
        if (product.comparePrice && product.comparePrice !== product.price) {
          priceHtml += '<span class="hauswirt-social-videos-modal__product-price--compare">' + product.comparePrice + '</span>';
        }
        priceHtml += '</p>';

        var addToCartHtml = '';
        if (product.available && product.variantId) {
          addToCartHtml = '<button type="button" class="hauswirt-social-videos-modal__add-to-cart" data-variant-id="' + product.variantId + '">Add to Cart</button>';
        } else {
          addToCartHtml = '<button type="button" class="hauswirt-social-videos-modal__add-to-cart" disabled>Sold Out</button>';
        }

        card.innerHTML =
          '<a href="' + product.url + '">' +
            (product.image ? '<img class="hauswirt-social-videos-modal__product-image" src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="hauswirt-social-videos-modal__product-info">' +
            '<a href="' + product.url + '" style="text-decoration:none;color:inherit;">' +
              '<p class="hauswirt-social-videos-modal__product-title">' + escapeHtml(product.title) + '</p>' +
            '</a>' +
            priceHtml +
            '<div class="hauswirt-social-videos-modal__product-actions">' +
              addToCartHtml +
              '<a href="' + product.url + '" class="hauswirt-social-videos-modal__product-cta">Shop now →</a>' +
            '</div>' +
          '</div>';

        var addBtn = card.querySelector('.hauswirt-social-videos-modal__add-to-cart');
        if (addBtn && product.available) {
          addBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            addToCart(product.variantId, addBtn);
          });
        }

        modalProducts.appendChild(card);
      });
    }

    function addToCart(variantId, btn) {
      btn.classList.add('is-loading');
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          btn.classList.remove('is-loading');
          setTimeout(function () { btn.textContent = 'Add to Cart'; }, 2000);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {
          btn.textContent = 'Add to Cart';
          btn.classList.remove('is-loading');
        });
    }

    /* ===== Embed URL generation ===== */
    function getEmbedUrl(url) {
      if (!url) return null;
      var platform = detectPlatform(url);

      if (platform === 'tiktok') {
        var tiktokId = extractTikTokId(url);
        if (tiktokId) return 'https://www.tiktok.com/embed/v2/' + tiktokId + '?lang=en';
      }
      if (platform === 'instagram') {
        var instaMatch = url.match(/instagram\.com\/(p|reel|reels)\/([A-Za-z0-9_-]+)/);
        if (instaMatch) {
          var instagramType = instaMatch[1] === 'p' ? 'p' : 'reel';
          return 'https://www.instagram.com/' + instagramType + '/' + instaMatch[2] + '/embed/';
        }
      }
      if (platform === 'youtube') {
        var ytId = extractYouTubeId(url);
        if (ytId) return 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0';
      }
      if (platform === 'facebook') {
        return 'https://www.facebook.com/plugins/video.php?href=' + encodeURIComponent(url) + '&show_text=true&width=400';
      }
      return null;
    }

    function extractTikTokId(url) {
      var match = url.match(/\/video\/(\d+)/);
      if (match) return match[1];
      match = url.match(/(\d{15,})/);
      if (match) return match[1];
      return null;
    }

    function extractYouTubeId(url) {
      var match = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
      return match ? match[1] : null;
    }

    function detectPlatform(url) {
      if (!url) return 'unknown';
      if (url.indexOf('tiktok.com') !== -1 || url.indexOf('vm.tiktok') !== -1) return 'tiktok';
      if (url.indexOf('instagram.com') !== -1) return 'instagram';
      if (url.indexOf('youtube.com') !== -1 || url.indexOf('youtu.be') !== -1) return 'youtube';
      if (url.indexOf('facebook.com') !== -1 || url.indexOf('fb.watch') !== -1) return 'facebook';
      return 'unknown';
    }

    /* ===== Creator name extraction ===== */
    function extractUsernameFromUrl(url) {
      if (!url) return null;
      var m = url.match(/tiktok\.com\/@([A-Za-z0-9_.]+)/);
      if (m) return '@' + m[1];
      m = url.match(/youtube\.com\/@([A-Za-z0-9_.-]+)/);
      if (m) return '@' + m[1];
      m = url.match(/facebook\.com\/([A-Za-z0-9_.]+)\/(?:videos|reel)/);
      if (m && m[1] !== 'watch' && m[1] !== 'reel') return '@' + m[1];
      return null;
    }

    function fetchCreatorName(url, callback) {
      if (!url) return;
      var platform = detectPlatform(url);
      var oembedUrl = null;

      if (platform === 'tiktok') {
        oembedUrl = 'https://www.tiktok.com/oembed?url=' + encodeURIComponent(url);
      } else if (platform === 'youtube') {
        oembedUrl = 'https://www.youtube.com/oembed?url=' + encodeURIComponent(url) + '&format=json';
      } else if (platform === 'instagram') {
        oembedUrl = 'https://noembed.com/embed?url=' + encodeURIComponent(url);
      } else if (platform === 'facebook') {
        oembedUrl = 'https://noembed.com/embed?url=' + encodeURIComponent(url);
      }

      if (!oembedUrl) return;

      fetch(oembedUrl, { mode: 'cors' })
        .then(function (res) {
          if (!res.ok) throw new Error('oEmbed failed');
          return res.json();
        })
        .then(function (data) {
          var name = data.author_name || data.author_url || '';
          if (name) {
            if (name.indexOf('@') !== 0 && name.indexOf('http') !== 0) {
              name = '@' + name;
            } else if (name.indexOf('http') === 0) {
              var pathMatch = name.match(/\/([^/]+)\/?$/);
              name = pathMatch ? '@' + pathMatch[1] : '';
            }
            callback(name);
          }
        })
        .catch(function () {});
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
  }
})();
